import { CrudList } from '../shared/CrudPage';
import { customerService } from '@kss/api';
import type { Customer, CustomerCreate, CustomerFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

const TYPE_BADGE: Record<string, string> = {
  B2C: 'bg-info/10 text-info',
  B2B: 'bg-success/10 text-success',
  B2B2C: 'bg-warning/10 text-warning',
};

export default function AllCustomers() {
  return (
    <CrudList<Customer, CustomerCreate, CustomerFilter>
      title="Customers"
      newLabel="New customer"
      service={customerService}
      idKey="customerId"
      labelKey="name"
      basePath="/panel/customers"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        {
          accessor: 'customerType',
          title: 'Type',
          width: 90,
          render: (r) =>
            r.customerType ? (
              <span className={`inline-flex rounded px-2 py-0.5 text-xs font-medium ${TYPE_BADGE[r.customerType] ?? ''}`}>
                {r.customerType}
              </span>
            ) : '—',
        },
        { accessor: 'phone', title: 'Phone', width: 140, render: (r) => r.phone || '—' },
        { accessor: 'email', title: 'Email', filterable: true, render: (r) => r.email || '—' },
        { accessor: 'gstin', title: 'GSTIN', width: 160, render: (r) => r.gstin || '—' },
        {
          accessor: 'creditLimit',
          title: 'Credit limit',
          width: 130,
          render: (r) =>
            r.creditLimit != null
              ? r.creditLimit.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 })
              : '—',
        },
        {
          accessor: 'isActive',
          title: 'Status',
          width: 110,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} />,
        },
      ]}
    />
  );
}
